import React from 'react';
import { FilterBuilder } from './filters';
import { patientFilterCategories } from '@/config/patientFilterMeta';
import { getPresetCategories } from '@/config/patientPresets';
import { FilterRecord } from '@/types/filterBuilder';
import { PatientFilterResult } from '@/config/patientFilterConfig';

interface PatientFilterBuilderProps {
  onApplyFilters: (filters: PatientFilterResult) => void;
  activeFilters?: PatientFilterResult | null;
  onClearFilters?: () => void;
}

export function PatientFilterBuilder({
  onApplyFilters,
  activeFilters,
  onClearFilters,
}: PatientFilterBuilderProps) {
  const handleApplyFilters = (filters: FilterRecord) => {
    // Cast to PatientFilterResult for type safety
    onApplyFilters(filters as PatientFilterResult);
  };

  return (
    <FilterBuilder
      categories={patientFilterCategories}
      presetCategories={getPresetCategories()}
      entityName="Patient"
      onApplyFilters={handleApplyFilters}
      activeFilters={activeFilters}
      onClearFilters={onClearFilters}
    />
  );
}

export default PatientFilterBuilder;
